<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" width="96" height="96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor">
        <path
          d="M32.197 26.632a6.365 6.365 0 1 0-12.73 0 6.365 6.365 0 0 0 12.73 0ZM49.473 26.632a6.365 6.365 0 1 0-12.73 0 6.365 6.365 0 0 0 12.73 0ZM25.832 37.543a6.365 6.365 0 1 1 0 12.73 6.365 6.365 0 0 1 0-12.73ZM32.197 60.275a6.365 6.365 0 1 0-12.73 0 6.365 6.365 0 0 0 12.73 0ZM59.475 20.267a6.365 6.365 0 1 1 0 12.73 6.365 6.365 0 0 1 0-12.73ZM41.952 76.492l32.683-.002a2.966 2.966 0 0 0 2.965-2.965V43.946a2.966 2.966 0 0 0-2.965-2.965l-15.702.001v7.414l11.254-.002v20.672l-23.776.002v-8.171h-7.413v12.619a2.959 2.959 0 0 0 2.965 2.965l-.01.01Z"
        />
        <path d="M53.29 55.158H37.6v-15.69h15.69v15.69Z" />
      </g>
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
